import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import './PracticePerfectQuizzes.css';
import Header from '../../Header/Header';
import { withAuth } from "../../../app/util/HOC";
export function PPComparativeQuizzes() {
    const { isbn } = useParams();
    const history = useHistory();
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const ppPageInfo = JSON.parse(localStorage.getItem('ppLandingInfo'));
    const ppCompPageInfo = JSON.parse(localStorage.getItem('ppCompQuizInfo'));
    const [compCustTime, setCompCustTime] = useState();
    const [compCustMaxQues, setCompCustMaxQues] = useState();
    const [compTakeQuizErrMsg, setCompTakeQuizErrMsg] = useState('');
    const [subTopicNames, setSubTopicNames] = useState(ppCompPageInfo.ppTopicNames);
    const [compSelMaxQues, setCompSelMaxQues] = useState(Number(ppCompPageInfo.totalQuestions));
    const handleBackToQuizCenter = () => {
        history.push(`/pp-quiz-center/${isbn}`);
    }
    const handleCustQuizRadioBtn = (radioBtn) => {
        if (radioBtn === "custQuesRadBtn") {
            document.getElementById('custQuesRadBtn').checked = true;
        } else if (radioBtn === "custTimRadBtn") {
            document.getElementById('custTimRadBtn').checked = true;
        }
    }
    const handleCustQuizTakeQuizBtn = () => {
        var maxQuesRadBtnChe = document.getElementById('maxQuesRadBtn').checked,
            custQuesRadBtnChe = document.getElementById('custQuesRadBtn').checked,
            maxTimRadBtnChe = document.getElementById('maxTimRadBtn').checked,
            custTimRadBtnChe = document.getElementById('custTimRadBtn').checked;
        var takeQuizErrMsg = '', takeQuizType = ppCompPageInfo.quizType, takeQuizTopics = [];
        if (maxQuesRadBtnChe === true && maxTimRadBtnChe === true) {
            takeQuizErrMsg = '';
        } else if (maxQuesRadBtnChe === true && custTimRadBtnChe === true) {
            if (compCustTime === undefined || compCustTime <= 0) {
                takeQuizErrMsg = 'Please enter a time limit.';
            } else if (compCustTime > 300) {
                takeQuizErrMsg = 'Please enter a time limit between 1 and 300 minutes.';
            } else {
                takeQuizErrMsg = '';
            }
        } else if (custQuesRadBtnChe === true && maxTimRadBtnChe === true) {
            if (compCustMaxQues === undefined || compCustMaxQues <= 0) {
                takeQuizErrMsg = 'Please enter a valid number of questions.';
            } else if (compCustMaxQues > compSelMaxQues) {
                takeQuizErrMsg = 'Please enter a number of questions between 1 and ' + compSelMaxQues + '.';
            } else {
                takeQuizErrMsg = '';
            }
        } else if (custQuesRadBtnChe === true && custTimRadBtnChe === true) {
            if (compCustTime === undefined || compCustTime <= 0) {
                takeQuizErrMsg = 'Please enter a time limit.';
            } else if (compCustTime > 300) {
                takeQuizErrMsg = 'Please enter a time limit between 1 and 300 minutes.';
            } else if (compCustMaxQues === undefined || compCustMaxQues <= 0) {
                takeQuizErrMsg = 'Please enter a valid number of questions.';
            } else if (compCustMaxQues > compSelMaxQues) {
                takeQuizErrMsg = 'Please enter a number of questions between 1 and ' + compSelMaxQues + '.';
            } else {
                takeQuizErrMsg = '';
            }
        }
        setCompTakeQuizErrMsg(takeQuizErrMsg);
        if (takeQuizErrMsg === '') {
            ppCompPageInfo.ppSubTopicVOList.map(ppSubTopic => {
                takeQuizTopics.push(ppSubTopic.subTopictagId);
            });
            localStorage.setItem('quCeGraModeQuizData', JSON.stringify({
                "isGraded": true,
                "quizType": takeQuizType,
                "subTopicTagId": takeQuizTopics,
                "quizTiming": custTimRadBtnChe === true ? compCustTime : 300,
                "totalQuestions": custQuesRadBtnChe === true ? compCustMaxQues : compSelMaxQues
            }));
            history.push(`/pp-quiz/graded/${isbn}/${ppPageInfo.ProductID}/${ppPageInfo.SATagId +
                (((takeQuizType).toLowerCase() === 'summative a' || (takeQuizType).toLowerCase() === 'comparative1') ?
                    "/comparative-a" : ((takeQuizType).toLowerCase() === 'summative b' || (takeQuizType).toLowerCase() === 'comparative2') ?
                        "/comparative-b" : ((takeQuizType).toLowerCase() === 'comparative3') ?
                            "/comparative-c" : ((takeQuizType).toLowerCase() === 'comparative4') ?
                                "/comparative-d" : ((takeQuizType).toLowerCase() === 'cumulative' || (takeQuizType).toLowerCase() === 'cumulative2') ?
                                    "/comparative-all-topics" : "/comparative")
                }`);
        }
    }
    return (
        <>
            <Header userVO={userVO} pageName="CCPracticePerfect" isbn={isbn}></Header>
            <div className='container'>
                <div className="card ppQuizCenterContainerSection">
                    <div className="card-body ppQuizCenterContainerCard">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="ppQuizCenterLogoContainer">
                                    <p>
                                        <span className='ppQuizCenterCommonStyle ppQuizCenterLogoBoldText'>PracticePerfect<sup>TM</sup></span>
                                        <span className='ppQuizCenterCommonStyle ppQuizCenterLogoText'>{ppPageInfo.ProductName}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-12'>
                                <div className='ppQuizCenterCommonStyle ppQuizCenterTitle mb-1'> Quiz Center</div>
                                <div className='ppQuizCenterCommonStyle ppQuizCenterText mb-3'>
                                    {
                                        ((ppCompPageInfo.quizType).toLowerCase() === 'summative a' || (ppCompPageInfo.quizType).toLowerCase() === 'comparative1') ?
                                            `Comparative Quiz A` :
                                            ((ppCompPageInfo.quizType).toLowerCase() === 'summative b' || (ppCompPageInfo.quizType).toLowerCase() === 'comparative2') ?
                                                `Comparative Quiz B` :
                                                ((ppCompPageInfo.quizType).toLowerCase() === 'comparative3') ?
                                                    `Comparative Quiz C` :
                                                    ((ppCompPageInfo.quizType).toLowerCase() === 'comparative4') ?
                                                        `Comparative Quiz D` :
                                                        ((ppCompPageInfo.quizType).toLowerCase() === 'cumulative' || (ppCompPageInfo.quizType).toLowerCase() === 'cumulative2') ?
                                                            `Comparative Quiz: All Topics` : null
                                    } {' : '}
                                    {
                                        subTopicNames.map((stName, index) => {
                                            return (
                                                stName +
                                                (index === subTopicNames.length - 2 ? " and " : "") +
                                                (index <= subTopicNames.length - 3 ? ", " : "")
                                            )
                                        })
                                    }
                                </div>
                                <div className="pwQuizCenterBackBtn col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                                    <a onClick={() => handleBackToQuizCenter()}>
                                        <span className="fa fa-chevron-left fa-sm" style={{ fontWeight: '600' }}></span>
                                        <span style={{ paddingLeft: '4px', fontSize: '15px' }}>Back to Quiz Center</span>
                                    </a>
                                </div>
                                <div className='pwQuizCustomize'>
                                    <p className='ppQuizCenterCommonStyle ppQuizCenterTitle mb-1 mt-4'> Customize your quiz</p>
                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-1'>
                                            <p className='ppQuizCenterCommonStyle ppQuizCenterText'>
                                                Number of questions {compSelMaxQues !== undefined ? `(Max: ` + compSelMaxQues + ` questions)` : null}
                                            </p>
                                            <div className="form-check ml-5 mb-3">
                                                <input data-testid="input_radio_maximum_questions" type="radio" className="form-check-input" name="radioBtn1" id="maxQuesRadBtn"
                                                    onClick={() => {setCompCustMaxQues(""); setCompTakeQuizErrMsg("");}} defaultChecked={true} />
                                                <label className="ppQuizCenterCommonStyle pwQuizSubTopicHeader"> Maximum </label>
                                            </div>
                                            <div className="form-check ml-5">
                                                <input data-testid="input_radio_custom_questions" type="radio" className="form-check-input" name="radioBtn1" id="custQuesRadBtn" />
                                                <input data-testid="input_questions" type="number" className="pwQuesInput mr-1 rounded-0" value={compCustMaxQues}
                                                    onChange={(e) => setCompCustMaxQues(e.target.value)} onClick={() => handleCustQuizRadioBtn("custQuesRadBtn")} />
                                                <label className="ppQuizCenterCommonStyle pwQuizSubTopicHeader"> questions</label>
                                            </div>
                                        </div>
                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-1'>
                                            <p className='ppQuizCenterCommonStyle ppQuizCenterText'>Time Limit</p>
                                            <div className="form-check ml-5 mb-3">
                                                <input data-testid="input_radio_unlimited_time" type="radio" className="form-check-input" name="radioBtn2" id="maxTimRadBtn"
                                                    onClick={() => {setCompCustTime(""); setCompTakeQuizErrMsg("");}} defaultChecked={true} />
                                                <label className="ppQuizCenterCommonStyle pwQuizSubTopicHeader"> Unlimited Time</label>
                                            </div>
                                            <div className="form-check ml-5">
                                                <input data-testid="input_radio_custom_time" type="radio" className="form-check-input" name="radioBtn2" id="custTimRadBtn" />
                                                <input data-testid="input_time" type="number" className="pwQuesInput mr-1 rounded-0" value={compCustTime}
                                                    onChange={(e) => setCompCustTime(e.target.value)} onClick={() => handleCustQuizRadioBtn("custTimRadBtn")} />
                                                <label className="ppQuizCenterCommonStyle pwQuizSubTopicHeader"> minutes</label>
                                            </div>
                                        </div>
                                    </div>
                                    {compTakeQuizErrMsg && <p className='pwTakeQuizErrTxt mt-2'>{compTakeQuizErrMsg}</p>}
                                </div>
                                <button className='pwTakeQuizBtn' onClick={() => handleCustQuizTakeQuizBtn()}>Take Graded Quiz</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withAuth(PPComparativeQuizzes);